export class PanelConfig {
  static SCROLL_ATTRIBUTE = 'data-scroll';
}
